module.exports = __webpack_public_path__ + "static/uts-preview_1600.c716651d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/projects/uts-web-media/uts-preview_1600.jpg
// module id = 479
// module chunks = 177050494245383